import { Component, inject } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ContactsPermissions } from '@backoffice/shared/bo/util-permissions';
import {
  BaseTableFilter,
  CommonWhereConditionsService,
  FilterKeyConditionType,
  SearchTableFilterComponent,
} from '@clean-code/shared/components/ui-data-table';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
    selector: 'limit-report-other-search',
    templateUrl: './limit-report-other-search.component.html',
    imports: [
        ReactiveFormsModule,
        MatSlideToggleModule,
        NgxPermissionsModule,
        TranslocoModule,
        SearchTableFilterComponent,
    ]
})
export class LimitReportOtherSearchComponent extends BaseTableFilter {
  public override filterControl = new UntypedFormGroup({
    onlyOwned: new UntypedFormControl(true),
  });

  public contactsPermission = ContactsPermissions;

  private whereService = inject(CommonWhereConditionsService);

  setFilterKeyConditions(): FilterKeyConditionType[] {
    return [
      this.whereService.onlyOwnedCondition(
        this.filterControl.get('onlyOwned').value,
        undefined,
        'customer',
      ),
    ];
  }
}
